@if (notificationCenterStore.unreadNotificationCount() > 0) {
  <span class="header-navigation__badge">
    @if (notificationCenterStore.unreadNotificationCount() > 9) {
      9+
    } @else {
      {{ notificationCenterStore.unreadNotificationCount() }}
    }
  </span>
}
<a class="navigation-link" (click)="openNotificationModal()">
  <span class="navigation-icon notifications" [pTooltip]="'navigation.notifications' | transloco" tooltipPosition="bottom"></span>
</a>
